import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import type { FavoriteListFloatingFooterProps } from './type'

import { ActionFloatingFooter } from '@/components/layout'
import { Button } from '@/components/ui'

export const FavoriteListFloatingFooter = ({
  isLoading,
  onClickUpdate,
  onCancel,
}: FavoriteListFloatingFooterProps) => {
  const { t } = useTranslation()

  return (
    <ActionFloatingFooter>
      <div
        className={clsx(
          'tw-w-full',
          'tw-grid tw-grid-cols-5 tw-items-center lg:tw-grid-cols-2',
          'tw-gap-2 lg:tw-gap-4'
        )}
      >
        <div className={clsx('tw-col-span-2 lg:tw-col-span-1')}>
          <Button
            variant={'secondary'}
            isBlock={true}
            disabled={isLoading}
            onClick={onCancel}
          >
            {t('favorite.modal.close')}
          </Button>
        </div>
        <div className={clsx('tw-col-span-3 lg:tw-col-span-1')}>
          <Button
            variant={'primary'}
            isBlock={true}
            isLoading={isLoading}
            onClick={onClickUpdate}
          >
            {`${t('pages.common.save')}`}
          </Button>
        </div>
      </div>
    </ActionFloatingFooter>
  )
}
